import React from 'react'
import {useSelector} from 'react-redux'
import { Fragment} from 'react'
import classNames from 'classnames'
import _ from 'lodash'
let Dsgvo = function(props){

  const dsgvo = useSelector(state => state.dsgvo)
  let dsgvoText = useSelector(state => state.dsgvo.text).trim()

  const input_width = useSelector(state => state.input_width) ? useSelector(state => state.input_width) : "8"
  const label_width = useSelector(state => state.label_width) ? useSelector(state => state.label_width) : "3"
  
  return (
    <Fragment>
      {dsgvo.enabled && 
        <div className="form-group row r-gdpr" id="form-group-gdpr-acception" key={"col" +  "dsgvo"}>
          <label className={"col-md-" + label_width + " r-label optional-label col-form-label"}></label>
          <div className={"col-md-" + input_width + ""}>
            <div className="form-check">
              <input name="gdpr_confirmation.base" id="gdpr_confirmation.base" ref={props.register} type="checkbox" className={classNames("form-check-input", { "is-invalid": props.errors && props.errors.gdpr_confirmation && props.errors.gdpr_confirmation.base })}/>
              <label htmlFor="gdpr_confirmation.base" className="form-check-label dsgvo-label" dangerouslySetInnerHTML={{ __html: dsgvoText}}></label>
              {props.errors && props.errors.gdpr_confirmation && props.errors.gdpr_confirmation.base  && <div className="invalid-feedback" dangerouslySetInnerHTML={{ __html: props.errors.gdpr_confirmation.base.message}}></div>}
            </div>
          </div>
        </div>
      }
    </Fragment>
  )
}
export default Dsgvo;